import { Injectable, signal } from '@angular/core';
import { IFilterState } from '../../models/IFilterState';
import { IFilterCategoryState } from '../../models/IFilterCategoryState';

@Injectable({
  providedIn: 'root'
})

export class PaginatorStateService {


  private readonly SORAGE_KEY = 'pagination';
  private readonly FILTERS_KEY = 'filters';
  private readonly CATEGORY_FILTERS_KEY = 'categoryFilters';

  private pagination = signal<{ page: number; per: number }>(this.loadFromSession() ?? { page: 1, per: 30 });
  // private filterSignal = signal<FilterState>(this.loadSearchFromSession() ?? {});

  // filters = this.filterSignal.asReadonly();

  setPagination(page: number, per: number) {
    if (typeof window !== 'undefined') {
      const value = { page, per };
      sessionStorage.setItem(this.SORAGE_KEY, JSON.stringify(value));
      this.pagination.set(value);
    }
  }

  reset() {
    if (typeof window !== 'undefined') {

      // console.log('reset paginator');
      sessionStorage.removeItem(this.SORAGE_KEY);
      const defaultValue = { page: 1, per: 30 };
      sessionStorage.setItem(this.SORAGE_KEY, JSON.stringify(defaultValue));
      this.pagination.set(defaultValue);
    }
  }

  getPagination() {
    return this.pagination();
  }

  private loadFromSession() {
    if (typeof window !== 'undefined') {
      const stored = sessionStorage.getItem(this.SORAGE_KEY);
      return stored ? JSON.parse(stored) : null;
    }
  }

  setFilters(filters: IFilterState)  {
    if (typeof window !== 'undefined') {
      sessionStorage.setItem(this.FILTERS_KEY, JSON.stringify(filters));
    }
  }

  setCategoryFilters(filters: IFilterCategoryState) {
    if (typeof window !== 'undefined') {
      sessionStorage.setItem(this.CATEGORY_FILTERS_KEY, JSON.stringify(filters));
    }
  }

  getFilters(): IFilterState | null {
    if (typeof window !== 'undefined') {
      const stored = sessionStorage.getItem(this.FILTERS_KEY);
      return stored ? JSON.parse(stored) : null;
    }
    return null;
  }

  getCategoryFilters(): IFilterCategoryState | null {
    if (typeof window !== 'undefined') {
      const stored = sessionStorage.getItem(this.CATEGORY_FILTERS_KEY);
      return stored ? JSON.parse(stored) : null;
    }
    return null;
  }

  clearFilters() {
    if (typeof window !== 'undefined') {
      sessionStorage.removeItem(this.FILTERS_KEY);
    }
  }

  clearCategoryFilters() {
    if (typeof window !== 'undefined') {
      sessionStorage.removeItem(this.CATEGORY_FILTERS_KEY);
    }
  }
  

}
